module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1022-12f331553ee778e7144d43b93004f77f.png";